import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useFetchPlugins } from '../react-query';

export const PluginsContext = React.createContext();

export const PluginsContextProvider = ({ children }) => {
  const [selectedPluginId, setSelectedPluginId] = useState(null);

  const { data, isLoading } = useFetchPlugins();
  const pluginList = data?.records;
  const hasPlugins = !!pluginList?.length;

  return (
    <PluginsContext.Provider
      value={{
        selectedPluginId,
        setSelectedPluginId,
        pluginList,
        hasPlugins,
        isLoading
      }}
    >
      {children}
    </PluginsContext.Provider>
  );
};

PluginsContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const usePluginsContext = () => {
  const { selectedPluginId, setSelectedPluginId, pluginList, hasPlugins, isLoading } =
    useContext(PluginsContext);

  return {
    selectedPluginId,
    setSelectedPluginId,
    pluginList,
    hasPlugins,
    isLoading
  };
};



// WEBPACK FOOTER //
// ./src/hooks/contexts/usePluginsContext.js